export default __webpack_public_path__ + "static/media/gallery_01.fbb0a945.jpg";